import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "~/lib/utils"

const alertVariants = cva("h-alert", {
  variants: {
    variant: {
      info: "h-alert--info",
      destructive: "h-alert--error",
      warning: "h-alert--warning",
      success: "h-alert--success",
    },
    size: {
      small: "h-alert--sm",
      large: "h-alert--lg",
    },
    layout: {
      compact: "h-alert--compact",
    },
  },
})

const Alert = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & VariantProps<typeof alertVariants>
>(({ className, variant, size, layout, ...props }, ref) => (
  <div ref={ref} role="alert" className={cn(alertVariants({ variant, size, layout }), className)} {...props} />
))
Alert.displayName = "Alert"

const AlertIcon = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => <div ref={ref} className={cn("h-alert__icon-wrapper", className)} {...props} />,
)
AlertIcon.displayName = "AlertIcon"

const AlertTitle = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLHeadingElement>>(
  ({ className, ...props }, ref) => <div ref={ref} className={cn("h-alert__title", className)} {...props} />,
)
AlertTitle.displayName = "AlertTitle"

const AlertContent = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => <div ref={ref} className={cn("h-alert__content", className)} {...props} />,
)
AlertContent.displayName = "AlertContent"

const AlertDescription = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLParagraphElement>>(
  ({ className, ...props }, ref) => <div ref={ref} className={cn("h-alert__description", className)} {...props} />,
)
AlertDescription.displayName = "AlertDescription"

const AlertActions = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => <div ref={ref} className={cn("h-alert__actions", className)} {...props} />,
)
AlertActions.displayName = "AlertActions"

export { Alert, AlertTitle, AlertDescription, AlertIcon, AlertContent, AlertActions }
